import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {SimulationSession} from '../../data/SimulationSession';
import {Model} from '../../data/Model';
import {ModelsDataProvider} from '../../data/ModelsDataProvider';
import * as aristoGlobals from '../../globals';
import {AristoDialogComponent} from '../../aristo-dialog/aristo-dialog.component';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-step3-price',
  templateUrl: './step3-price.component.html',
  styleUrls: ['./step3-price.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class Step3PriceComponent implements OnInit {

  @Input() simulationSession!: SimulationSession;
  @Output() simulationSessionChange: EventEmitter<SimulationSession> = new EventEmitter<SimulationSession>();
  @Output() leftButton: EventEmitter<any> = new EventEmitter<any>();
  @Output() rightButton: EventEmitter<any> = new EventEmitter<any>();

  formatLabel(value: number) {
    return value + '€';
  }

  constructor(private modelsDataProvider: ModelsDataProvider, public dialog: MatDialog) {
  }

  ngOnInit(): void {
  }

  leftButtonClicked(){
    this.saveModel();
    this.leftButton.emit();
  }

  rightButtonClicked(){
    if (this.isValid()) {
      this.saveModel();
      this.rightButton.emit();
    }
  }

  saveModel() {
    this.simulationSessionChange.emit(this.simulationSession);
  }

  isValid(): boolean {
    if (this.simulationSession.priceAriston && this.simulationSession.priceAriston > 0 && this.simulationSession.priceTrad  &&
      this.simulationSession.priceTrad > 0 ) {
      return true;
    }
    else {
      this.dialog.open(AristoDialogComponent, { data: { dialogText: 'MESSAGES.ERRORS.PRICE_ERROR'}});
      return false;
    }
  }
}
